/**
 * Capitalize the first letter of a string
 */
export function capitalize(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Truncate a string to a specified length
 */
export function truncate(str: string, maxLength: number, suffix: string = '...'): string {
  if (!str || str.length <= maxLength) return str;
  return str.slice(0, maxLength - suffix.length) + suffix;
}

/**
 * Generate initials from a name
 */
export function getInitials(name: string, maxLength: number = 2): string {
  if (!name) return '';
  return name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, maxLength)
    .join('');
}

/**
 * Get localized name from an object with name, name_en, name_ru fields
 */
export function getLocalizedName(
  obj: { name: string; name_en?: string; name_ru?: string } | undefined | null,
  lang: string,
): string {
  if (!obj) return '-';
  if (lang === 'ru' && obj.name_ru) return obj.name_ru;
  if (lang === 'en' && obj.name_en) return obj.name_en;
  return obj.name;
}
